import { TabInfoBase } from 'app/buffer-graph/models/tab-info-base';
import { ItemOrderHistory } from 'app/buffer-graph/models/item-order-history/item-order-history';
import { ItemOrderHistoryFresh } from 'app/buffer-graph/models/item-order-history/item-order-history-fresh';
import { StateInfo } from 'app/buffer-graph/models/assortment-structure/state-info';
import { BalanceStructure } from 'app/buffer-graph/models/assortment-structure/balance-structure';

type Data = { states: StateInfo[], balanceStructure: BalanceStructure };

export class AssortmentStructureTabInfo extends TabInfoBase<Data> {
    constructor(data: Data) {
        super('AssortmentStructure', data);
    }

    get id(): string {
        return AssortmentStructureTabInfo.id;
    }

    static readonly id = 'AST';
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/assortment-structure/assortment-structure-tab-info.ts